import React from 'react';
import MessageBox from '../../../components/MessageBox';

const ButtonWithLoader = ({ action, text, loading, className ,type}) => {
    return (
        <button className={` ${className ? className : "px-4 py-2 rounded-2"}`} type={type ? type : "button"} onClick={action} disabled={loading}>{loading ? <div className='custom-loading mx-auto'></div> : <MessageBox text={text} />} </button>
    )
}

export default ButtonWithLoader